<template>
    <div class="collapse-div" :style="{height: now_height}">
        <img class="collapse-img collapse-icon" v-bind:class="{ 'closed': type=='closed' }" src="../../assets/img/open.png" @click="clickImg()">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: {
          height: {
            type: String
          }
        },
        data(){
          return {
              type: 'open',
              now_height: '100px',
              min_height: '29px'
          }
        },
        created(){
          this.now_height = this.height
        },
        methods: {
          clickImg(){
            if(this.type == 'open'){
              this.type = 'closed'
              this.now_height = '29px'
            }else{
              this.type = 'open'
              this.now_height = this.height
            }
          }
        }
    }
</script>

<style scoped>
  .collapse-div{
      /*border: 1px solid #DCDFE6;*/
      min-height: 29px;
      position: relative;
      -webkit-transition: -webkit-transform .3s;
      transition: -webkit-transform .3s;
      transition: transform .3s;
      transition: transform .3s,-webkit-transform .3s;
      overflow:hidden
  }

  .collapse-img{
    width: 21px;
    position: absolute;
    right: 20px;
    top: 10px;
    cursor: pointer;
    z-index: 150;
  }

  .closed{
    transform:rotate(180deg);
    -ms-transform:rotate(180deg); /* IE 9 */
    -moz-transform:rotate(180deg); /* Firefox */
    -webkit-transform:rotate(180deg); /* Safari and Chrome */
    -o-transform:rotate(180deg); /* Opera */
  }

  .collapse-icon{
    -webkit-transition: -webkit-transform .3s;
    transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s,
    -webkit-transform .3s;
  }



</style>



// WEBPACK FOOTER //
// src/components/XrCollapse/index.vue